module.exports = __webpack_public_path__ + "static/media/create.fbb953f0.svg";